export interface DefaultMapTooltipFields {
  id?: string;
  fields: string[];
}

export const DEFAULT_MAP_TOOLTIP_FIELDS_SETTING: DefaultMapTooltipFields = {
  fields: ["Header.EntityName", "Header.Operator_Short", "Dates.Vintage_Year"]
};

export const DEFAULT_FACILITY_MAP_TOOLTIP_FIELDS_SETTING: DefaultMapTooltipFields = {
  fields: [
    "Header.FacilityId",
    "Header.FacilityName",
    "Header.OperatorName",
    "Header.FacilityType"
  ]
};
